export enum UserRoleEnum {
  ACCOUNT_OWNER = "ACCOUNT_OWNER",
  ADMIN = "ADMIN",
  CONTRIBUTOR = "CONTRIBUTOR",
  REVIEWER = "REVIEWER",
}
